module.exports = __webpack_public_path__ + "c2b575886f2a31b1ae23d1874b38e0de.pdf";